import AdaptiveImage from "../../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "plus_liste.png",
    width: 32,
    height: 32
});